import * as React from 'react'

import withCms from 'cms/with-cms'
import withLayout from 'cms/with-layout'
import { localRouteFormatters } from 'configuration/manifest'
import { NextPage } from 'next'

import { withErrorPage, withServerRouteFormatters } from '@grandvisionhq/next'
import { compose } from '@grandvisionhq/utils'
import { InitialProps, Page, Props } from '@grandvisionhq/www-next/pages/returns/confirmation'

import '@grandvisionhq/fun-returns/dist/index.css'

const ReturnsPage: NextPage<Props, InitialProps> = (props) => <Page {...props} />

ReturnsPage.getInitialProps = Page.getInitialProps

export default compose<Props, Props>(
  withCms(),
  withLayout({
    hasOnlyLogoInHeader: true,
    footer: false,
  }),
  withErrorPage(),
  withServerRouteFormatters(localRouteFormatters)
)(ReturnsPage)
